import { createFileRoute } from "@tanstack/react-router";
import { type } from "arktype";

import { ManualDocument } from "./-components/manuais-document";

const idParam = type("string.integer.parse | number.integer");

const paramsSchema = type({
	id: type("string | number").pipe((raw) => {
		const id = idParam(raw);

		if (id instanceof type.errors) {
			return null;
		}

		return id;
	}),
});

export const Route = createFileRoute("/_app/clinica/manual/$id")({
	params: {
		parse: (raw) => paramsSchema.assert(raw),
		stringify: ({ id }) => ({ id: String(id) }),
	},
	component: ManualEditorPage,
});

function ManualEditorPage() {
	const { id } = Route.useParams();

	if (id === null) {
		return null;
	}

	return <ManualDocument id={id} />;
}
